module.exports = __webpack_public_path__ + "static/media/avatar.c175d331.jpg";